import {
  getAllProjectsBySearchValue,
  getObjectsBySearchValue,
} from "../../reducers/ui/selectors/searchSelectors";
import { updateSearchData } from "../../reducers/ui/uiReducer";
import { AppStore } from "../../store";

export const changeSearchValue = (value: string) => {
  return async (store: AppStore) => {
    if (!value.length) {
      store.dispatch(
        updateSearchData({
          searchValue: "",
          searchFolders: [],
          searchProjects: [],
          searchProducts: [],
        })
      );
      return;
    }

    const state = store.getState();

    const objects = getObjectsBySearchValue(value)(state);
    const projects = getAllProjectsBySearchValue(value)(state);

    store.dispatch(
      updateSearchData({
        searchValue: value,
        searchFolders: objects,
        searchProjects: projects,
      })
    );
  };
};
